import { render, staticRenderFns } from "./OrderTabs.vue?vue&type=template&id=b111ac44&scoped=true&"
import script from "./OrderTabs.vue?vue&type=script&lang=ts&"
export * from "./OrderTabs.vue?vue&type=script&lang=ts&"
import style0 from "./OrderTabs.vue?vue&type=style&index=0&id=b111ac44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b111ac44",
  null
  
)

export default component.exports